import { base44 } from "@/api/base44Client";

// Fetches a reCAPTCHA v3 token for a public, unauthenticated form submission.
// Resolves to null if the script is blocked/unavailable/times out — server-side
// verification treats a missing token as a soft failure, not a hard block.
export async function getRecaptchaToken(action) {
  try {
    const { data } = await base44.functions.invoke("getRecaptchaSiteKey", {});
    const siteKey = data?.site_key;
    if (!siteKey) return null;

    if (!window.grecaptcha) {
      await new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    }
    const tokenPromise = new Promise((resolve, reject) => {
      window.grecaptcha.ready(() => {
        window.grecaptcha.execute(siteKey, { action }).then(resolve).catch(reject);
      });
    });
    const timeoutPromise = new Promise((resolve) => setTimeout(() => resolve(null), 8000));
    return await Promise.race([tokenPromise, timeoutPromise]);
  } catch {
    return null;
  }
}